import vue from 'vue';

export default function buildMoveContainerStore(store){
    store.actions.setState = async (context, params) => await  vue.prototype.$myHttp.post('/api/moveContainers/setState', params);
    return store;
}
